import styled from 'styled-components'
import { Icon } from '@navent-jobs/ui-kit/components/icon'

export const ParagraphInfo = styled.p`
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.secondary.normal};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  margin-bottom: 32px;
`

export const IconCustom = styled(Icon)`
  margin-right: 6px;
`
